export default __webpack_public_path__ + "03edf90755cbe5dae2757573b461ff3b.png";